export const subscriptionDurationFormat = ({
    length_years,
    length_days,
}: {length_years?: number, length_days?: number}) => 
`${length_years ? `${length_years} year${length_years > 1 ? 's' : ''}` : ''}${length_years && length_days ? ', ' : ''}${length_days ? `${length_days} day${length_days > 1 ? 's' : ''}` : ''}`